<template>
<div class="chapter">
<div class="inner_page">
<div id="Front">
<p class="front-para">… Though much is taken, much abides; and though<br/>We are not now that strength which in the old days<br/>Moved earth and heaven, that which we are, we are,<br/>One equal temper of heroic hearts,<br/>Made weak by time and fate, but strong in will<br/>To strive, to seek, to find, and not to yield.</p>
<p class="right">Alfred Lord Tennyson, <i>Ulysses</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Front.vue?fcf1074e